import * as yup from "yup";

import { FormikProvider, useFormik } from "formik";

import Button from "react-bootstrap/Button";
import DropdownWithFormik from "../Dropdown/DropdownWithFormik";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import SubmitButton from "../../components/SubmitButton";
import TextInputWithFormik from "../TextInput/TextInputWithFormik";
import { useTranslation } from "next-i18next";
import { useReasons } from "../../utils/checkoutReasonsHook";
import { useEffect, useState } from "react";

const CheckoutModal = ({ open, toggleModal, line, onSubmit }) => {
  const { t } = useTranslation();
  const onCancel = () => {
    resetForm();
    toggleModal();
  };

  const loadReasons = useReasons();

  const [reasons, setReasons] = useState([]);

  useEffect(() => {
    loadReasons(line?.is_misc).then((r) => setReasons(r));
  }, [line?.is_misc, loadReasons]);

  const fieldRequired = t("general.validation.required");
  const validationSchema = yup.object().shape({
    reason: yup.object().required(fieldRequired),
    description: yup.string().when("reason", (reason, schema) => {
      if (reason?.value === "OTHER") {
        return schema.required(fieldRequired);
      } else {
        return schema;
      }
    }),
  });

  const formik = useFormik({
    initialValues: {
      reason: "",
      description: "",
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      onSubmit(values, resetForm, setSubmitting);
      toggleModal();
    },
    validationSchema,
  });

  const { handleSubmit, resetForm, setSubmitting, values } = formik;
  return (
    <Modal show={open} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <div className="d-flex flex-column">
          <h1 className="fw-bold mb-0" style={{ color: "#333333" }}>
            {t("views.checkin.checkout.title")}
          </h1>
          <p className="text-muted mb-0">
            {t("views.checkin.checkout.subtitle")}
          </p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form noValidate onSubmit={handleSubmit}>
          <FormikProvider value={formik}>
            <DropdownWithFormik
              label={t("views.checkin.checkout.form.reason")}
              name="reason"
              options={reasons}
              required
            />
            <TextInputWithFormik
              label={t("views.checkin.checkout.form.description")}
              name="description"
              type="text"
              placeholder=""
              required={values.reason?.value === "OTHER"}
            />
          </FormikProvider>
          <div
            className={`mt-4 d-flex flex-column justify-content-center border-top flex-sm-row`}
            style={{
              paddingTop: 26,
              marginLeft: -32,
              marginRight: -32,
            }}
          >
            <Button variant="secondary" onClick={onCancel} className="me-3">
              {t("general.cancel")}
            </Button>
            <SubmitButton
              loading={false}
              label={t("views.checkin.form.checkout")}
            />
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CheckoutModal;
